<template lang="pug">
  div
    .notification.is-warning 
        span Vous pouvez encore générer 
        span {{ 3 - answers.length }}&nbsp;
        span réponse{{ (3 - answers.length) > 1 ? 's' : '' }}
    .columns.is-multiline
      .column.is-12(style="padding-bottom: 0px;")
        .block(v-if="generating")
          span En cours de génération (par l'assistant {{this.selectedAssistant.name}})
        .block.notification.is-danger(v-if="generation_error")
          span Erreur lors de la génération: {{generation_error_message}}
        .block
          button.button.btn.btn-outline-primary.is-fullwidth(v-if="!generating" @click="generateAdditionalAnswer") Générer une autre réponse
    //- Modal Section
    .modal(:class="{ 'is-active': showModal }")
      .modal-background(@click="closeModal")
      .modal-card
        header.modal-card-head
          p.modal-card-title Générer une autre réponse
          button.delete(@click="closeModal" aria-label="close")
        section.modal-card-body
          .columns.is-multiline
            .column.is-12
              input.input(type="text" v-model="searchQuery" placeholder="Filtrer par nom ou LLM name")
            .column.is-12
              div
                button.button(@click="sortByName") Trier par Nom
                button.button(@click="sortByEloGlobal") Trier par ELO global
            .column.is-12(v-for="assistant in filteredAndSortedAssistants" :key="assistant.name")
              .box(:class="{ 'is-clickable': true, 'selected': selectedAssistant == assistant }" @click="selectedAssistant = assistant" style="box-radius: 4px;")
                h5
                  strong {{assistant.name}}
                .tags
                  span.tag ELO:&nbsp;
                    strong(v-if="assistant.elo_score") {{ assistant.elo_score }}
                    strong(v-else) pas de partie jouée
                  span.tag {{assistant.step_set[0].llm_name}}
                  span.tag(v-if="assistant.created_by") créé par: {{ assistant.created_by.username }}
                  span.tag(v-else) créé par Logos
                  span.tag Température: {{ assistant.step_set[0].temperature }}
                  span.tag Stratégie d'exemples: {{ assistant.step_set[0].example_choice_strategy || assistant.step_set[0].example_selection_strategy || assistant.step_set[0].example_fill_strategy }}
              //- .card(:class="{ 'is-clickable': true, 'selected': selectedAssistant == assistant }" @click="selectedAssistant = assistant")
              //-   .card-content
              //-     p.title {{ assistant.name }}
              //-     p {{ assistant.step_set[0].llm_name }} - {{ assistant.step_set[0].temperature }} - {{ assistant.step_set[0].example_choice_strategy || assistant.step_set[0].example_selection_strategy || assistant.step_set[0].example_fill_strategy }} - {{ assistant.elo_global }}
          .column.is-12
            textarea.textarea(type="text" v-model="userInput" placeholder="Vous pouvez ici affiner votre demande à l'Assistant: ajouter une information, demander de corriger un élément de la réponse précédente, etc")
        footer.modal-card-foot
          button.button.btn.btn-outline-primary(@click="generate_additional_answer" :disabled="selectedAssistant === null") Générer
          button.button(@click="closeModal") Annuler
</template>

<script>
import gql from '@/gqlService';
import query from '@/gql/queries';
import mutations from '@/gql/mutations'
import Vue from 'vue'
import settings from '../settings.coffee'

export default {
  name: 'LogosAdditionalAnswer',
  props: {
    review: Object,
    answers: Array
  },
  data() {
    return {
      generating: false,
      generation_error: false,
      generation_error_message: null,
      showCard: false,
      showModal: false,
      assistants: [],
      selectedAssistant: null,
      userInput: '',
      searchQuery: '',
      sortKey: '',
    };
  },
  async created() {
    await this.fetchAssistants();
  },
  methods: {
    async fetchAssistants() {
      try {
        const resp = await query.run_v2('assistants');
        this.assistants = resp.body.data.assistants.filter(assistant => assistant.is_active);
      } catch (error) {
        console.error('Error fetching assistants:', error);
      }
    },
    generateAdditionalAnswer() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async generate_additional_answer() {
      const self = this
      this.generating = true;
      this.generation_error = false
      this.generation_error_message = null
      this.closeModal();
      var query = mutations.review_generate_logos_answer(
              this.review.uid,
              this.selectedAssistant.uid,
              this.userInput
      )
      try {
        const resp = await Vue.http.post(settings.graphqlApiUrl, {query: query})
        if (resp.ok == true){
          if (resp.body.data.review_generate_logos_answer.ok == false){
            this.generation_error = true
            if (resp.body.data.review_generate_logos_answer) {
              // everything was ok but the final result is not good
              this.generation_error_message = resp.body.data.review_generate_logos_answer.msg
            } else {
              // answer is ok but the error is here (GraphQL specificity)
              this.generation_error_message = resp.body.errors[0].message
            }
          } else {
            this.$emit('trigger-fetch-review')
            this.$emit('trigger-fetch-answers')
            this.generating = false;
          }
        } else {
            this.generation_error = true
            this.generation_error_message = resp.statusText
        }
        this.generating = false;
      } catch (error) {
        console.log("ERROR generate_additional_answer", error)
        this.generation_error = true
        this.generation_error_message = error.data.review_generate_logos_answer
        this.generating = false;
      }


    },
    sortByName() {
      this.sortKey = 'name';
    },
    sortByEloGlobal() {
      this.sortKey = 'elo_global';
    }
  },
  computed: {
    filteredAndSortedAssistants() {
      let filtered = this.assistants.filter(assistant => {
        return assistant.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
               assistant.step_set[0].llm_name.toLowerCase().includes(this.searchQuery.toLowerCase());
      });

      if (this.sortKey) {
        filtered.sort((a, b) => {
          if (this.sortKey === 'name') {
            return a.name.localeCompare(b.name);
          } else if (this.sortKey === 'elo_global') {
            return b.elo_global - a.elo_global;
          }
          return 0;
        });
      }

      return filtered;
    }
  }
};
</script>

<style scoped>
.columns {
  display: flex;
  justify-content: center;
}
.card.is-clickable {
  cursor: pointer;
}
.card.selected {
  background-color: #77dd77; /* vert pastelle */
}
.modal-card {
  max-width: 90%;
}
</style>
